<template>
  <div class="ic-test" :class="{'web':!isMobile}">
    <div class="header">
      <van-image width="3.8rem" height="auto" :src="ypLogo" />
      <span class="name">Internship Challenge </span>
    </div>

    <div v-if="!isSubmitted" class="content">
      <van-collapse v-model="collapseActive" accordion style="margin-bottom: 0.5rem;">
        <van-collapse-item title="Internship Challenge Test" value="View Details" name="1">
          <p>Part I: Individual Written Test:</p>
          <p>
            Halmart Group’s (‘The Group’) operations comprise two reportable segments: Halmart and Jack's Club. Each week, the group serve over 240 million customers who visit approximately 11,400 stores.</p>
          <p>Jack’s Club is a world leading membership store. Each member will pay RMB 200 to gain one-year membership. In 2018, Jack’s Club in China achieved 8% same-store sales growth in China’s market, with almost 80% membership renewal rate. In 2019, Jack’s Club had double-digit sales growth driven by higher sales across all channels.</p>
          <p>Jack’s Club china market strategy is that creating more online-to-offline experiences by bringing together its strengths in digital and physical retail. Website, Wechat and APP are the online sales channels. Most of the goods (include fresh food and imported products) can be delivered within one day.</p>
          <table class="table">
            <tbody>
              <tr>
                <td />
                <td colspan="3">
                  Year ended December 31 (RMB in millions)
                </td>
              </tr>
              <tr>
                <th />
                <th>2020</th>
                <th>2019</th>
                <th>2018</th>
              </tr>
              <tr>
                <th>Revenues:</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
              <tr>
                <td> &nbsp;&nbsp;&nbsp;Net sales</td>
                <td> 555,233
                </td>
                <td> 519,926
                </td>
                <td> 510,329
                </td>
              </tr>
              <tr>
                <td> &nbsp;&nbsp;&nbsp;Membership income</td>
                <td>3,918</td>
                <td>4,038</td>
                <td>4,076</td>
              </tr>
              <tr>
                <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Total revenues</td>
                <td>559,151</td>
                <td>523,964</td>
                <td>514,405</td>
              </tr>
              <tr>
                <th>Costs and expenses:</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
              <tr>
                <td>&nbsp;&nbsp;&nbsp;Cost of sales</td>
                <td> (420,315)</td>
                <td> (394,605)</td>
                <td> (385,301)</td>
              </tr>
              <tr>
                <td>&nbsp;&nbsp;&nbsp;Operating, selling, &nbsp;&nbsp;&nbsp;general* and &nbsp;&nbsp;&nbsp;administrative &nbsp;&nbsp;&nbsp;expenses</td>
                <td> (116,288)</td>
                <td> (108,791)</td>
                <td> (107,147)</td>
              </tr>
              <tr>
                <th>Operating income</th>
                <td> 22,548</td>
                <td> 20,568</td>
                <td> 21,957</td>
              </tr>
            </tbody>
          </table>
          <p>*Advertising costs were $3.2 billion, $3.7 billion and $3.5 billion for fiscal 2020, 2019 and 2018, respectively</p>
        </van-collapse-item>
      </van-collapse>
      <!-- <p class="text-primary mb-3">Please select the correct choice (each question worth 1 point)</p> -->
      <p class="text-primary mb-3">Please select the correct choice</p>
      <div v-for="(item,index) in questionList" :key="index">
        <van-divider />
        <h4 class="question-title">{{ item.key }}: {{ item.question }}</h4>
        <van-radio-group v-model="item.answer" :disabled="isSubmitted">
          <van-radio v-for="(i,n) in item.options" :key="n.key" :name="i.key">{{ i.key }}. {{ i.label }}</van-radio>
        </van-radio-group>
      </div>
    </div>
    <div v-if="!isSubmitted" class="bottom">
      <van-button block type="primary" :disabled="isSubmitted" @click="readySubmit">Submit</van-button>
    </div>
    <div v-else class="content">
      <embed :src="submitIcon" style="width:2.4rem; display: block; margin: 0.2rem auto;">
      <div style="text-align: center">
        <h3 class="text-primary" style="font-size: 0.32rem;">Thank you!</h3>
        <p>Thank you for your participation.</p>
        <p class="text-muted">You will have 4 minutes to interview with assessors individually, including test-related questions and behavior questions. please be prepared.</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getIcTestStatus, setIcTestStatus } from '@/util/auth'
import {
  Image,
  Collapse,
  CollapseItem,
  Loading,
  Toast,
  RadioGroup,
  Radio,
  Divider,
  Notify,
  Dialog
} from 'vant'
import { http } from '@/api'
import { Account, IcTest } from '@/api/collection'
import ypLogo from '@/assets/logo.png'
import submitIcon from '@/assets/submit.svg'

import Detect from '@/util/detect'
const isMobile = Detect(window.navigator.userAgent).mobile()

const questionList = [
  {
    key: 'Q1',
    question:
      'What is the gross profit margin for the year ended 2020 and 2019?',
    options: [
      { key: 'A', label: ' 138,836 and 129,359' },
      { key: 'B', label: ' 138,836 and 129,104' },
      { key: 'C', label: ' 129,359 and 129,104' },
      { key: 'D', label: ' 240,000 and 138,836' }
    ],
    answer: ''
  },
  {
    key: 'Q2',
    question:
      'How many paid members does Jack’s Club have at 2020?',
    options: [
      { key: 'A', label: '17.4 millions' },
      { key: 'B', label: '22.3 millions' },
      { key: 'C', label: '19.6 millions' },
      { key: 'D', label: '20.9 millions' }
    ],
    answer: ''
  },
  {
    key: 'Q3',
    question:
      'Jack\'s Club\'s business is seasonal to a certain extent due to calendar events and national and religious holidays, as well as different weather patterns. Please forecast which of the following had occurred the highest sales volume.',
    options: [
      { key: 'A', label: 'The fiscal quarter ending January 31' },
      { key: 'B', label: 'The fiscal quarter ending April 30' },
      { key: 'C', label: 'The fiscal quarter ending July 31' },
      { key: 'D', label: 'The fiscal quarter ending October 31' }
    ],
    answer: ''
  }
]

export default {
  name: 'Share',
  components: {
    [Image.name]: Image,
    [Loading.name]: Loading,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Divider.name]: Divider,
    [Notify.name]: Notify,
    [Dialog.name]: Dialog
  },
  props: {
    isWeb: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      leadId: '',
      ypLogo,
      submitIcon,
      isMobile,
      collapseActive: '',
      questionList: questionList,
      isSubmitted: false
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  // 创建前设置
  beforeCreate() {
    if (!isMobile) {
      document.querySelector('html').setAttribute('style', 'font-size: 64px;')
    }
  },
  async mounted() {
    // 判断是否登录
    if (this.userInfo && this.userInfo.token && this.userInfo.leadId) {
      console.log('已登录')
    } else {
      this.$router.push({
        path: '/simpleLogin',
        query: { redirect: this.$route.fullPath },
        replace: true
      })
      return
    }
    Toast.loading({
      message: '加载中...',
      duration: 5000,
      forbidClick: true
    })
    await this.getLeadInfo()
    Toast.clear()

    // 检查是否有cookie记录
    const cookieObj = getIcTestStatus()
    if (Object.keys(cookieObj).length !== 0) {
      if (cookieObj.leadId === this.leadId && cookieObj.isSubmitted) {
        this.isSubmitted = true
      }
    }
  },
  methods: {
    async getLeadInfo() {
      const res = await http({
        path: Account.GetBaseInfo.path,
        method: Account.GetBaseInfo.method,
        data: {}
      })
      if (res.resultCode === '0') {
        this.leadId = res.leadBaseInfo.leadId
      }
    },
    readySubmit() {
      let notFinished = false

      this.questionList.forEach((item) => {
        if (item.answer === '') {
          notFinished = true
        }
      })

      if (notFinished) {
        Notify({
          type: 'danger',
          message: '您还有未完成的题',
          duration: 3 * 1000
        })
        return false
      }

      Dialog.confirm({
        title: '提交答案',
        message: '提交答案后将不得修改，请确认是否提交'
      })
        .then(async() => {
          this.submit()
        })
        .catch(() => {
          console.log('Cancel submit')
        })
    },
    // 提交答案
    async submit() {
      Toast.loading({
        message: '提交中...',
        duration: 5000,
        forbidClick: true
      })
      const res = await http({
        path: IcTest.SaveICAMorPMScore.path,
        method: IcTest.SaveICAMorPMScore.method,
        data: {
          leadId: this.leadId,
          amorPM: 'AM',
          QAScore: this.questionList.map((item) => {
            return {
              question: item.key,
              answer: item.answer
            }
          })
        }
      })
      if (res.resultCode === '0') {
        this.isSubmitted = true
        setIcTestStatus({ leadId: this.leadId, isSubmitted: true })
        Toast.clear()
        Toast.success({
          message: res.resultMsg,
          duration: 1000,
          forbidClick: true
        })
      } else if (res.resultCode === '1') {
        Toast.clear()
        Toast.fail({
          message: res.resultMsg,
          duration: 5000,
          forbidClick: true
        })

        this.isSubmitted = true
        setIcTestStatus({ leadId: this.leadId, isSubmitted: true })
      }
    }
  }
}
</script>
<style>
:root {
  --primary-color: #d04a02;
  --tangerine-color: #eb8c00;
  --yellow-color: #ffb600;
}
/* web端 */
.ic-test.web {
  max-width: 480px;
  margin: 0 auto;
  box-shadow: 0 0 500px 500px #e8e8e8;
}

.ic-test {
  min-height: 100vh;
  padding-bottom: 1.6em;
  background-color: #f9f9f9;
}
.text-primary {
  color: #d04a02;
}
.text-muted {
  color: #7d7d7d !important;
}
.ic-test .header {
  display: flex;
  align-items: flex-end;
  padding: 0.6rem 0.4rem 0.4rem;
  background-color: #fff;
  box-shadow: 0 0 8px #eee;
}
.ic-test .header .name {
  margin-left: 0.3rem;
  margin-bottom: 0.02rem;
  color: #7d7d7d;
  font-size: 0.28rem;
}
.ic-test .content {
  margin-top: 0.3rem;
  padding: 0.4rem 0.4rem;
  background-color: #fff;
  box-shadow: 0 0 8px #eee;
  font-size: 0.28rem;
}
.question-title {
  color: #2d2d2d;
  font-size: 0.3rem;
}
.ic-test .bottom {
  display: flex;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 0.3rem;
  background-color: rgba(255, 255, 255, 0.9);
}
.ic-test.web .bottom {
  max-width: 480px;
}
.ic-test .van-radio {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
}
.ic-test .van-radio__label {
  margin-left: 0.16rem;
  line-height: 0.4rem;
}
.ic-test .van-radio-group {
  font-size: 0.28rem;
}
.ic-test .van-cell {
  padding: 0.2rem 0;
}
.ic-test .van-cell__value {
  flex-grow: 0;
  flex-basis: 10em;
}
.ic-test .van-collapse-item__content {
  padding: 0.2rem 0;
  color: #4d4d4d;
}
.ic-test .table {
  width: 100%;
  margin-bottom: 0.4rem;
  border-collapse: collapse;
}
.ic-test .table th,
.ic-test .table td {
  border: 1px solid #e0e0e0;
  padding: 0.14rem;
  text-align: left;
}
.bg-light {
  background-color: #fff7ee;
}
</style>
